export default {
  getOrderCancelReasons: '/courier/api/v2/order/cancel/check',
  abortOrder: '/gateway/capp/order/courierOrderService/abortOrder',
  queryCourierChance: '/v3/cancelOrder/queryCourierChance',
  punishRule: '/courier/api/v2/order/cancel/punish/rule',
  locationRule: '/courier/api/v2/order/cancel/before/location/rule',
  beforeAbort: '/courier/api/v2/order/cancel/before/abort',
  goodsCheck: '/courier/api/v2/order/cancel/before/goods/check',
  douYinCheck: '/courier/api/v2/order/cancel/before/douYinCheck'
}
